import { API_ROOT } from "config.js";

const USER_DETAILS_ENDPOINT = `${API_ROOT}/api/users/`;
const NOTIFICATIONS_ENDPOINT = `${API_ROOT}/api/notifications/`;
const ACTIVITIES_ENDPOINT = `${API_ROOT}/api/activities/`;

export async function getData(axios, user_id) {
  let url = `${USER_DETAILS_ENDPOINT}`;
  if (user_id) {
    url = `${USER_DETAILS_ENDPOINT}${user_id}/`;
  }
  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function updateData(axios, user_id, userData) {
  let payload = userData;
  if (userData.avatarFile) {
    payload = new FormData();
    payload.append("file", userData.avatarFile);
    delete userData["avatarFile"];

    const json = JSON.stringify(userData);
    const blob = new Blob([json], {
      type: "application/json"
    });
    payload.append("document", blob);
  }
  const response = await axios.post(
    `${USER_DETAILS_ENDPOINT}${user_id}/`,
    payload
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function create(axios, user_id, userData) {
  const response = await axios.post(
    `${USER_DETAILS_ENDPOINT}${user_id}/`,
    userData
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getNotifications(axios) {
  const response = await axios.get(`${NOTIFICATIONS_ENDPOINT}`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function readNotification(axios, notification_id) {
  let payload = {
    unread: false
  };
  const response = await axios.post(
    `${NOTIFICATIONS_ENDPOINT}${notification_id}/`,
    payload
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getActivities(
  axios,
  userId,
  platform,
  fetchTrainees,
  activity_id,
  startTime,
  endTime
) {
  let url = `${ACTIVITIES_ENDPOINT}`;
  if (activity_id) {
    url = `${ACTIVITIES_ENDPOINT}${activity_id}`;
  } else if (platform || fetchTrainees || userId) {
    url = `${ACTIVITIES_ENDPOINT}?`;
    if (platform) {
      url += `platform=${platform}`;
    }
    if (fetchTrainees) {
      url += `&includeTrainees=${fetchTrainees}`;
    }
    if (userId) {
      url += `&userId=${userId}`;
    }
    if (startTime) {
      url += `&startTime=${startTime}`;
    }
    if (endTime) {
      url += `&endTime=${endTime}`;
    }
  }

  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function updateActivity(axios, activityId, activityData) {
  const response = await axios.put(
    `${ACTIVITIES_ENDPOINT}${activityId}/`,
    activityData
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function registerUserDevice(axios, deviceToken) {
  const response = await axios.post(
    `${USER_DETAILS_ENDPOINT}register_device_token/`,
    {
      deviceToken: deviceToken
    }
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getHealthMetricsData(axios, user_id) {
  let url = `${USER_DETAILS_ENDPOINT}`;
  if (user_id) {
    url = `${USER_DETAILS_ENDPOINT}${user_id}`;
  }
  url = url + "/health-metrics/";
  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function updateHealthMetricsData(axios, user_id, userData) {
  let url = `${USER_DETAILS_ENDPOINT}`;
  if (user_id) {
    url = `${USER_DETAILS_ENDPOINT}${user_id}`;
  }
  url = url + "/health-metrics/";
  let payload = userData;
  if (userData.avatarFile) {
    payload = new FormData();
    payload.append("file", userData.avatarFile);
    delete userData["avatarFile"];

    const json = JSON.stringify(userData);
    const blob = new Blob([json], {
      type: "application/json"
    });
    payload.append("document", blob);
  }
  const response = await axios.post(url, payload);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getGoalProgress(axios, goalId) {
  let url = `${API_ROOT}/api/goals/${goalId}/progress`;
  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getTrainingNotes(
  axios,
  userId,
  page = 1,
  pageSize = 10,
  startDate = null,
  endDate = null
) {
  let url = `${API_ROOT}/api/training-notes`;
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString()
  });

  if (userId) {
    params.append("user_id", userId.toString());
  }

  if (startDate) {
    params.append("start_date", startDate);
  }

  if (endDate) {
    params.append("end_date", endDate);
  }

  url += `?${params.toString()}`;

  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getTrainingNoteConfig(axios, userId) {
  let url = `${API_ROOT}/api/training-notes/config`;

  if (userId) {
    url += `?user_id=${userId}`;
  }

  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function createTrainingNote(axios, trainingNoteData) {
  const response = await axios.post(
    `${API_ROOT}/api/training-notes/`,
    trainingNoteData
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function updateTrainingNote(axios, noteId, trainingNoteData) {
  const response = await axios.patch(
    `${API_ROOT}/api/training-notes/${noteId}/`,
    trainingNoteData
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function uploadTrainingNotesCSV(axios, csvFile, userId) {
  const formData = new FormData();
  formData.append("file", csvFile);
  if (userId) {
    formData.append("user_id", userId.toString());
  }

  const response = await axios.post(
    `${API_ROOT}/api/training-notes/bulk-upload/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function makeAPICall(axios, path, method, payload = null) {
  let response;
  const url = `${API_ROOT}` + path;
  if (method.toLowerCase() === "get") {
    response = await axios.get(url);
  } else if (method.toLowerCase() === "post") {
    response = await axios.post(url, payload);
  } else if (method.toLowerCase() === "put") {
    response = await axios.put(url, payload);
  } else if (method.toLowerCase() === "patch") {
    response = await axios.patch(url, payload);
  } else if (method.toLowerCase() === "delete") {
    response = await axios.delete(url);
  } else {
    throw new Error(`Unsupported HTTP method: ${method}`);
  }

  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}
